export const isPdf = (fileName: string): boolean => fileName.includes(".pdf");

export const isExcel = (fileName: string): boolean =>
  fileName.includes(".xls") || fileName.includes(".csv");

export const getFileName = (url: string) => url.split(".com/")[1];
